var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_15)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.913 232.694C221.342 211.015 254.377 142.832 232.697 80.4024C211.018 17.973 142.835 -15.0616 80.4056 6.61754C17.9762 28.2967 -15.0584 96.4801 6.62074 158.909C28.2999 221.339 96.4833 254.373 158.913 232.694Z",
    fill: "#F5FEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.323 125.659C239.323 125.659 239.323 214.489 140.173 237.559L63.7734 173.559L166.583 68.6191L239.323 125.659Z",
    fill: "#CFE3E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.845 48.1177L38.3047 60.752L56.6332 181.944L140.173 169.31L121.845 48.1177Z",
    fill: "#A8A6A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.936 50.6721L40.875 62.6289L58.5351 179.401L137.596 167.444L119.936 50.6721Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.212 94.2028L66.7344 101.686L67.4088 106.145L116.886 98.6621L116.212 94.2028Z",
    fill: "#DBE8EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.352 101.726L67.875 109.209L68.5494 113.668L118.027 106.186L117.352 101.726Z",
    fill: "#DBE8EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4513 113.516L69.0156 116.762L69.6908 121.221L91.1265 117.975L90.4513 113.516Z",
    fill: "#DBE8EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.847 126.019L79.5312 130.604L80.2057 135.063L110.521 130.478L109.847 126.019Z",
    fill: "#B7E0EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.995 133.564L80.6797 138.148L81.3541 142.608L111.669 138.023L110.995 133.564Z",
    fill: "#B7E0EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.128 141.118L81.8125 145.703L82.4869 150.162L112.802 145.578L112.128 141.118Z",
    fill: "#B7E0EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.825 65.1755L50.4922 74.4512L51.1666 78.9105L112.499 69.6348L111.825 65.1755Z",
    fill: "#B7E0EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.958 72.7302L51.625 82.0059L52.2994 86.4651L113.632 77.1895L112.958 72.7302Z",
    fill: "#B7E0EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.114 80.2536L52.7812 89.5293L53.4557 93.9886L114.788 84.7129L114.114 80.2536Z",
    fill: "#B7E0EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.689 148.864L83.3359 153.463L84.0124 157.928L114.366 153.329L113.689 148.864Z",
    fill: "#B7E0EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.259 157.326L84.0625 160.83L84.7361 165.289L107.933 161.785L107.259 157.326Z",
    fill: "#B7E0EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0938 101.679L60.8638 106.599L64.8638 97.0488L60.1538 103.159L57.0938 101.679Z",
    fill: "#FF8080"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4844 110.939L62.2644 115.859L66.2544 106.309L61.5544 112.429L58.4844 110.939Z",
    fill: "#FF8080"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8906 120.21L63.6606 125.13L67.6606 115.58L62.9506 121.69L59.8906 120.21Z",
    fill: "#FF8080"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9844 131.259L74.3544 135.659L77.9244 127.119L73.7144 132.589L70.9844 131.259Z",
    fill: "#FF8080"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2031 139.369L75.5731 143.759L79.1531 135.219L74.9431 140.689L72.2031 139.369Z",
    fill: "#FF8080"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4297 147.46L76.7997 151.87L80.3697 143.32L76.1697 148.79L73.4297 147.46Z",
    fill: "#FF8080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6484 155.56L78.0184 159.96L81.5984 151.43L77.3884 156.89L74.6484 155.56Z",
    fill: "#FF8080"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8828 163.66L79.2528 168.06L82.8228 159.52L78.6128 165L75.8828 163.66Z",
    fill: "#FF8080"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.582 68.6191H82.1016V191.189H166.582V68.6191Z",
    fill: "#A8A6A1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.319 70.8594H84.3594V188.949H164.319V70.8594Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.372 79.9492H104.852V88.9692H157.372V79.9492Z",
    fill: "#B7E0EB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5244 76.9395H89.2344V88.9695H99.5244V76.9395Z",
    fill: "#81CFE6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M159.017 132.41H103.117V136.11H159.017V132.41Z",
    fill: "#C8E4EB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M159.017 138.68H103.117V142.38H159.017V138.68Z",
    fill: "#C8E4EB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.017 144.939H103.117V148.639H159.017V144.939Z",
    fill: "#C8E4EB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.597 151.209H103.117V154.909H120.597V151.209Z",
    fill: "#C8E4EB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.947 169.02H103.117V172.72H122.947V169.02Z",
    fill: "#C8E4EB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.947 175.279H103.117V178.979H122.947V175.279Z",
    fill: "#C8E4EB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M122.947 181.549H103.117V185.249H122.947V181.549Z",
    fill: "#C8E4EB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.033 169.02H139.203V172.72H159.033V169.02Z",
    fill: "#C8E4EB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.033 175.279H139.203V178.979H159.033V175.279Z",
    fill: "#C8E4EB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M159.033 181.549H139.203V185.249H159.033V181.549Z",
    fill: "#C8E4EB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.357 103.17H109.297V107.68H139.357V103.17Z",
    fill: "#B7E0EB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M141.372 174.009C139.682 176.219 138.792 178.359 139.372 178.809C139.952 179.259 141.792 177.809 143.472 175.629C145.152 173.449 146.062 171.279 145.472 170.829C144.882 170.379 143.062 171.809 141.372 174.009Z",
    fill: "#B0751C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 142.359C190.31 122.199 200.66 104.219 198 102.179C195.34 100.139 180.7 114.859 165.29 135.019C149.88 155.179 139.53 173.169 142.18 175.199C144.83 177.229 159.48 162.469 174.9 142.359Z",
    fill: "#D85354"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M146.657 162.119C142.737 168.889 140.317 173.719 142.177 175.119C144.037 176.519 148.077 172.929 153.567 167.389L146.657 162.119Z",
    fill: "#FEA929"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M193.519 115.159C197.439 108.389 199.869 103.559 197.999 102.159C196.129 100.759 192.099 104.349 186.609 109.899L193.519 115.159Z",
    fill: "#FEA929"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.21 107.699C200.61 109.539 201.69 112.449 200.59 114.419L187.569 134.359C187.44 134.629 187.373 134.925 187.373 135.224C187.373 135.524 187.44 135.819 187.569 136.089C187.869 136.776 188.367 137.358 189 137.759C189.32 137.925 189.57 138.199 189.706 138.533C189.842 138.866 189.854 139.238 189.74 139.579C189.44 140.119 188.62 140.179 187.9 139.719C186.605 138.887 185.585 137.69 184.97 136.279C184.696 135.712 184.555 135.09 184.555 134.459C184.555 133.829 184.696 133.207 184.97 132.639L197.97 112.689C198.51 111.689 197.879 110.169 196.539 109.289C196.218 109.128 195.966 108.856 195.828 108.524C195.69 108.192 195.677 107.821 195.789 107.479C196.089 106.929 196.91 106.879 197.62 107.339C197.823 107.448 198.02 107.568 198.21 107.699Z",
    fill: "#FEA929"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M189.54 107.609C190.71 106.389 191.93 105.609 192.25 105.969C192.57 106.329 191.9 107.529 190.73 108.739C189.56 109.949 188.35 110.739 188.02 110.389C187.69 110.039 188.38 108.839 189.54 107.609Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_440_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 105,
    width: 63,
    height: 74
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.774 124.439C170.254 143.439 155.314 158.839 143.774 167.529C142.414 170.239 141.604 172.369 141.694 173.749L141.474 174.009C139.784 176.219 138.894 178.359 139.474 178.809C140.054 179.259 141.894 177.809 143.574 175.629C143.644 175.529 143.704 175.449 143.764 175.349C145.944 174.909 149.344 171.789 153.664 167.419L153.564 167.329C161.228 159.456 168.385 151.106 174.994 142.329C181.736 133.649 187.922 124.551 193.514 115.089L193.614 115.179C194.864 113.029 195.934 111.099 196.784 109.389C198.064 110.269 198.664 111.759 198.134 112.709L185.134 132.659C184.861 133.227 184.719 133.849 184.719 134.479C184.719 135.109 184.861 135.731 185.134 136.299C185.75 137.709 186.769 138.906 188.064 139.739C188.784 140.199 189.604 140.139 189.904 139.599C190.018 139.257 190.006 138.886 189.871 138.552C189.735 138.218 189.484 137.944 189.164 137.779C188.531 137.377 188.033 136.796 187.734 136.109C187.605 135.839 187.537 135.543 187.537 135.244C187.537 134.944 187.605 134.649 187.734 134.379L200.734 114.439C201.834 112.439 200.734 109.559 198.354 107.719C198.187 107.59 198.014 107.47 197.834 107.359H197.784C198.083 106.665 198.331 105.949 198.524 105.219C194.304 111.409 189.774 117.889 184.774 124.439Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_440_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.372 174.009C139.682 176.219 138.792 178.359 139.372 178.809C139.952 179.259 141.792 177.809 143.472 175.629C145.152 173.449 146.062 171.279 145.472 170.829C144.882 170.379 143.062 171.809 141.372 174.009Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9 142.359C190.31 122.199 200.66 104.219 198 102.179C195.34 100.139 180.7 114.859 165.29 135.019C149.88 155.179 139.53 173.169 142.18 175.199C144.83 177.229 159.48 162.469 174.9 142.359Z",
    fill: "#D85354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.665 162.119C142.745 168.889 140.325 173.719 142.185 175.119C144.045 176.519 148.085 172.929 153.575 167.389L146.665 162.119Z",
    fill: "#FEA929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.519 115.159C197.439 108.389 199.869 103.559 197.999 102.159C196.129 100.759 192.099 104.349 186.609 109.899L193.519 115.159Z",
    fill: "#FEA929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21 107.699C200.61 109.539 201.69 112.449 200.59 114.419L187.569 134.359C187.44 134.629 187.373 134.925 187.373 135.224C187.373 135.524 187.44 135.819 187.569 136.089C187.869 136.776 188.367 137.358 189 137.759C189.32 137.925 189.57 138.199 189.706 138.533C189.842 138.866 189.854 139.238 189.74 139.579C189.44 140.119 188.62 140.179 187.9 139.719C186.605 138.887 185.585 137.69 184.97 136.279C184.696 135.712 184.555 135.09 184.555 134.459C184.555 133.829 184.696 133.207 184.97 132.639L197.97 112.689C198.51 111.689 197.879 110.169 196.539 109.289C196.218 109.128 195.966 108.856 195.828 108.524C195.69 108.192 195.677 107.821 195.789 107.479C196.089 106.929 196.91 106.879 197.62 107.339C197.823 107.448 198.02 107.568 198.21 107.699Z",
    fill: "#FEA929"
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M143.669 169.529C144.669 167.869 145.779 166.699 146.169 166.939C146.559 167.179 146.069 168.709 145.079 170.359C144.089 172.009 142.969 173.199 142.579 172.959C142.189 172.719 142.679 171.199 143.669 169.529Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.32,
    height: 239.32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiTemplate);
export default __webpack_public_path__ + "static/media/multiTemplate.f9a17ebf89f9d7053fb9841520dff365.svg";
export { ForwardRef as ReactComponent };